<template lang="pug">
#dados-gerais-operacao
    card
        el-form(
            label-position='top',
            ref='dadosGerais',
            :model='dadosGerais',
            :rules='dadosGeraisRules'
        )
            h2 Dados Gerais
            .row
                .col-8
                    el-form-item(prop='nome')
                        template(slot='label')
                            span.label Nome
                        el-input(
                            v-model='dadosGerais.nome',
                            :maxlength='255',
                            placeholder='Nome'
                        )
                .col-4
                    el-form-item(prop='categoria')
                        template(slot='label')
                            span.label Categoria
                        el-select.w-100(
                            v-model='dadosGerais.categoria.id',
                            placeholder='Selecione',
                            @change='atualizarDadosGerais',
                            value-key='id'
                        )
                            el-option(
                                v-for='categoria in listaCategorias',
                                :key='categoria.id',
                                :label='categoria.nome',
                                :value='categoria.id'
                            )

                .col-12
                    el-form-item
                        template(slot='label')
                            span.label Descrição

                        el-input(
                            type='textarea',
                            :rows='5',
                            v-model='dadosGerais.descricao',
                            :maxlength='8000',
                            placeholder='Descrição',
                            @change='atualizarDadosGerais'
                        )
            .row
                .col-3
                    el-form-item(prop='identificadorOperacao')
                        template(slot='label')
                            span.label Identificador da Operação

                        el-input(
                            v-model='dadosGerais.identificadorOperacao',
                            :maxlength='17',
                            placeholder='Identificador da Operação',
                            @change='atualizarDadosGerais'
                        )
                .col-3
                    el-form-item(prop='numeroContrato')
                        template(slot='label')
                            span.label Número do Contrato

                        el-input(
                            v-model='dadosGerais.numeroContrato',
                            placeholder='Número do Contrato',
                            @change='atualizarDadosGerais'
                        )
                .col-2
                    el-form-item
                        template(slot='label')
                            span.label.pb-10 Data da Contratação

                        el-date-picker(
                            v-model='dadosGerais.dataContratacao',
                            type='date',
                            placeholder='Selecione',
                            format='dd/MM/yyyy',
                            disabledDate='',
                            style='width: 100%',
                            @change='atualizarDadosGerais'
                        )
                .col-2
                    el-form-item
                        template(slot='label')
                            span.label.pb-10 Data da Liberação

                        el-date-picker(
                            v-model='dadosGerais.dataLiberacao',
                            type='date',
                            placeholder='Selecione',
                            format='dd/MM/yyyy',
                            disabledDate='',
                            style='width: 100%',
                            @change='atualizarDadosGerais'
                        )
                .col-2
                    el-form-item
                        template(slot='label')
                            span.label.pb-10 Vigência

                        el-date-picker(
                            v-model='dadosGerais.vigencia',
                            :picker-options='datePickerOptions',
                            type='date',
                            placeholder='Selecione',
                            format='dd/MM/yyyy',
                            disabledDate='',
                            style='width: 100%',
                            @change='atualizarDadosGerais'
                        )
            .row
                .col-3
                    el-form-item
                        template(slot='label')
                            span.label Valor Total da Operação

                        money.campo-extendido.el-input__inner(
                            v-model='dadosGerais.valorTotalOperacao',
                            v-bind='moneyMask',
                            placeholder='Valor total da Operação'
                        )
</template>

<script>
import Card from '../../Card.vue';
import { Money } from 'v-money';
import OperacaoService from '@/services/OperacaoService';

export default {
    name: 'FormularioDadosGeraisOperacao',

    emits: ['dadosGerais', 'atualizaValidarDadosGerais'],

    props: {
        operacaoEditarOuClonar: {
            type: Object,
            required: false,
            default: null
        }
    },

    components: {
        Card,
        Money
    },

    data() {
        const validarCategoria = (rule, value, callback) => {
            if (!this.dadosGerais.categoria.id) {
                return callback(new Error('Categoria da Operação necessária'));
            }
            callback();
        };
        return {
            dadosGeraisRules: {
                identificadorOperacao: [
                    {
                        required: true,
                        message: 'Identificador da Operação necessário',
                        trigger: 'blur'
                    }
                ],
                categoria: [
                    {
                        required: true,
                        validator: validarCategoria,
                        trigger: 'change'
                    }
                ]
            },
            dadosGerais: {
                nome: '',
                descricao: '',
                identificadorOperacao: '',
                numeroContrato: '',
                categoria: {
                    id: null,
                    atividadeObrigatoria: false
                },
                vigencia: null,
                dataLiberacao: null,
                dataContratacao: null,
                valorTotalOperacao: 0
            },
            listaCategorias: [],
            objetoCicloAno: [],
            datePickerOptions: {
                disabledDate(date) {
                    const today = new Date();
                    today.setUTCHours(0, 0, 0, 0);
                    return date < today;
                }
            },
            moneyMask: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        };
    },

    async mounted() {
        await this.buscarCategorias();
        this.atualizarDadosGerais();
        setTimeout(this.verificarEdicao, 1000);
    },

    methods: {
        atualizarDadosGerais() {
            if (
                this.listaCategorias.length > 0 &&
                this.dadosGerais.categoria.id
            ) {
                this.dadosGerais.categoria.atividadeObrigatoria =
                    this.listaCategorias.find(
                        item => item.id === this.dadosGerais.categoria.id
                    ).atividadeObrigatoria;
            }

            this.$emit('dadosGerais', this.dadosGerais);
        },

        async buscarCategorias() {
            try {
                const { data } = await OperacaoService.buscarCategorias();
                this.listaCategorias = data.itens;
            } catch (error) {
                this.$notify.error({
                    message: error.message
                });
            }
        },

        async validarFormulario() {
            return this.$refs.dadosGerais
                .validate()
                .then(value => value)
                .catch(() => false);
        },

        verificarEdicao() {
            if (this.operacaoEditarOuClonar !== null) {
                this.dadosGerais = this.operacaoEditarOuClonar.dadosGerais;

                if (this.dadosGerais.vigencia !== null) {
                    let dataString =
                        this.dadosGerais.vigenciaFormatado.split('/');
                    this.dadosGerais.vigencia = new Date(
                        `${dataString[2]}/${dataString[1]}/${dataString[0]}`
                    );
                }

                if (this.dadosGerais.dataLiberacao !== null) {
                    let dataString =
                        this.dadosGerais.dataLiberacaoFormatado.split('/');
                    this.dadosGerais.dataLiberacao = new Date(
                        `${dataString[2]}/${dataString[1]}/${dataString[0]}`
                    );
                }

                if (this.dadosGerais.dataContratacao !== null) {
                    let dataString =
                        this.dadosGerais.dataContratacaoFormatado.split('/');
                    this.dadosGerais.dataContratacao = new Date(
                        `${dataString[2]}/${dataString[1]}/${dataString[0]}`
                    );
                }

                this.atualizarDadosGerais();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#dados-gerais-operacao {
    .label {
        font-size: 14px;
        color: var(--primary);
        font-weight: normal !important;
    }
}
</style>
